<template>
    <div class="VideoModal">
        <div class="VideoModal-video">
            <background-video
                v-if="src && src.length > 0"
                @click="videoToggle"
                @end="onEnd"
                @pause="onPause"
                @play="onPlay"
                @time="updateTimeVars"
                :auto-play="false"
                :loop="false"
                :muted="false"
                :containerHeight="containerHeight"
                :containerWidth="containerWidth"
                class="VideoModal-BackgroundVideo"
                ref="backgroundVideo"
                :src="src"
            ></background-video>
            <video-poster
                v-if="posterIsVisible"
                @click="videoPlay"
                :poster="poster"
                :fadeDuration="500"
                class="VideoModal-poster"
                ref="poster"
            ></video-poster>
        </div>
        <div class="VideoModal-blend blend-0" ref="blend0"></div>
        <div class="VideoModal-blend blend-1" ref="blend1"></div>
        <div
            v-if="!videoPlaying && showOverlay"
            class="VideoModal-overlay"
        >
            <div
                @click.stop="videoPlay"
                class="VideoModal-overlay-content"
            >
                <div class="VideoModal-overlay-content-wrapper">
                    <transition name="fade">
                        <div class="VideoModal-logo">
                            <img src="~/assets/img/logo.png" alt="">
                        </div>
                    </transition>

                    <div class="VideoModal-artist">
                        <svg class="VideoModal-artist-number" viewBox="0 0 50 35">
                            <text x="0" y="15">{{formattedArtistNumber}}</text>
                        </svg>

                        <text-transition
                            :charMinDuration="0.7"
                            :charMaxDuration="1.2"
                            :introDelay="0.1"
                            :outroDuration="0.5">
                            <p v-html="artistName" class="VideoModal-artist-name"></p>
                        </text-transition>
                    </div>
                </div>
            </div>
        </div>
        <div
            @click.stop="videoToggle"
            class="VideoModal-controls"
            ref="controls"
        >
            <div
                class="VideoModal-timeLine"
                ref="timeline"
            >
                <div class="VideoModal-timeLine-legend">Haz click para {{timeLineTextAction}} el video</div>
                <div class="VideoModal-timeLine-time">
                    <video-timeline
                        :currentTime="currentTime"
                        :duration="duration"
                    ></video-timeline>
                </div>
            </div>
            <social-share
                v-if="!videoPlaying && showOverlay"
                class="VideoModal-share"
                :url="shareURL"
            ></social-share>
        </div>
    </div>
</template>

<script>
    import TextTransition from "@/app/transitions/TextTransition";
    import BackgroundVideo from "foo/components/BackgroundVideo";
    import VideoPoster from "foo/components/VideoPoster";
    import VideoTimeline from "foo/components/VideoTimeline";
    import SocialShare from "@/app/components/SocialShare";

    export default {
        name: 'VideoModal',
        components: {
            TextTransition,
            BackgroundVideo,
            VideoPoster,
            VideoTimeline,
            SocialShare,
        },
        data() {
            return {
                containerHeight: 0,
                containerWidth: 0,
                currentTime: 0,
                duration: 0,
                hideControlsTimeout: undefined,
                progress: 0,
                videoEnded: false,
                videoPlayed: false,
                videoPlaying: false,
                showControls: true,
                showOverlay: true,
                showPoster: true,
                timeLineTexts: {
                    "pause": "pausar",
                    "continue": "continuar viendo",
                    "replay": "volver a ver",
                    "play": "reproducir"
                }
            };
        },
        props: {
            artistName: {
                type: String,
                default: undefined
            },
            artistNumber: {
                type: [Number, String],
                default: undefined
            },
            hideControlsTime: {
                type: Number,
                default: 2500
            },
            poster: {
                type: String
            },
            src: {
                type: [String, Array],
                default: undefined
            }
        },
        computed: {
            controlsVisible() {
                return this.showOverlay || this.showControls;
            },
            formattedArtistNumber() {
                if (
                    this.artistNumber &&
                    typeof this.artistNumber === "number"
                ) {
                    return this.artistNumber.toString().padStart(2, 0);
                } else if (
                    this.artistNumber &&
                    this.artistNumber === "string"
                ) {
                    return this.artistNumber;
                }
                return "00";
            },
            posterIsVisible() {
                return this.poster && this.showPoster;
            },
            timeLineTextAction() {
                if (this.videoPlaying) {
                    return this.timeLineTexts.pause;
                } else if (this.videoEnded) {
                    return this.timeLineTexts.replay;
                } else if (!this.videoPlayed) {
                    return this.timeLineTexts.play;
                } else {
                    return this.timeLineTexts.continue;
                }
            },
            shareURL() {
                return location.href;
            },
        },
        methods: {
            fadeIn($el, done) {
                console.log("enter anim")
                TweenMax.to($el, 1, {
                    delay: 0.2,
                    alpha: 1,
                    onComplete: done
                })
            },
            fadeOut($el, done) {
                TweenMax.to($el, 1, {
                    delay: 0.2,
                    alpha: 0,
                    onComplete: done
                })
            },
            blendFadeIn() {
                const {blend0, blend1} = this.$refs;
                const fadeTime = 0.35;
                TweenMax.to(blend0, fadeTime, {
                    autoAlpha: 1,
                    ease: Cubic.easeOut
                });
                TweenMax.to(blend1, fadeTime, {
                    autoAlpha: 0.77,
                    ease: Cubic.easeOut
                });
            },
            bladeFadeOut() {
                const {blend0, blend1} = this.$refs;
                const fadeTime = 0.35;
                TweenMax.to([blend0, blend1], fadeTime, {
                    autoAlpha: 0,
                    delay: this.$refs.poster ? 0.5 : 0,
                    ease: Cubic.easeOut
                });
            },
            controlsHide() {
                const {timeline} = this.$refs;
                TweenMax.to(timeline, 0.4, {
                    autoAlpha: 0,
                    yPercent: 100,
                    ease: Power3.easeInOut
                });
            },
            controlsShow() {
                const {timeline} = this.$refs;
                TweenMax.to(timeline, 0.4, {
                    autoAlpha: 1,
                    yPercent: 0,
                    ease: Power3.easeInOut
                });
            },
            eventsAdd() {
                window.addEventListener("resize", this.onResize);
                window.addEventListener("mousemove", this.onMouseMove);
            },
            eventsRemove() {
                window.removeEventListener("resize", this.onResize);
                window.removeEventListener("mousemove", this.onMouseMove);
            },
            hideControlsClearTimeOut() {
                if (this.hideControlsTimeout) {
                    clearTimeout(this.hideControlsTimeout);
                    this.hideControlsTimeout = undefined;
                }
            },
            hideControlsSetTimeout() {
                this.hideControlsClearTimeOut();
                this.hideControlsTimeout = setTimeout(() => {
                    this.showControls = false;
                    this.hideControlsClearTimeOut();
                }, this.hideControlsTime);
            },
            onEnd() {
                this.showPoster = true;
                this.videoEnded = true;
            },
            onMouseMove() {
                if (this.videoPlaying) {
                    this.showControls = true;
                    this.hideControlsSetTimeout();
                }
            },
            onPause() {
                this.showControls = true;
                this.videoPlaying = false;
                this.showOverlay = true;
            },
            onPlay() {
                this.hideControlsSetTimeout();
                this.videoEnded = false;
                this.videoPlaying = true;
                this.videoPlayed = true;
                this.showPoster = false;
                this.showOverlay = false;
            },
            onResize() {
                this.resize(window.innerHeight, window.innerWidth);
                this.posisionateControls();
            },
            posisionateControls() {
                const {
                    $refs: {
                        controls
                    },
                    showOverlay
                } = this;
                if (showOverlay) {
                    TweenMax.to(controls, 0.5, {
                        y: -window.innerHeight / 2 + 184,
                        ease: Power2.easeOut
                    });
                } else {
                    TweenMax.to(controls, 0.5, {
                        y: 0,
                        ease: Power2.easeOut
                    });
                }
            },
            resize(height, width) {
                this.containerHeight = height;
                this.containerWidth = width;
            },
            togglePlay() {
                const {backgroundVideo} = this.$refs;
                backgroundVideo.togglePlay();
            },
            updateTimeVars({currentTime, duration, progress}) {
                this.duration = duration;
                this.currentTime = currentTime;
                this.progress = progress;
            },
            videoPause() {
                this.$refs.backgroundVideo.pause();
            },
            videoPlay() {
                this.$refs.backgroundVideo.play();
            },
            videoToggle() {
                this.$refs.backgroundVideo.togglePlay();
            }
        },
        watch: {
            showOverlay(newValue) {
                this.posisionateControls();
                if (!this.videoPlaying && newValue) {
                    this.blendFadeIn();
                } else {
                    this.bladeFadeOut();
                }
            },
            controlsVisible(value) {
                if (value) {
                    this.controlsShow();
                } else {
                    this.controlsHide();
                }
            }
        },
        mounted() {
            this.eventsAdd();
            this.posisionateControls();
        },
        beforeDestroy() {
            this.eventsRemove();
        }
    }
</script>

<style src="styles/components/VideoModal.styl" lang="stylus"></style>



// WEBPACK FOOTER //
// src/app/components/VideoModal.vue